import { View } from "@/classes/inbox/View";
import { orderBy, query, Query, where } from "firebase/firestore";
import { store } from "@/store";
import { UserStore } from "@/store/constants";

export class ViewOpenOwn extends View {
  constructor() {
    super("Deine offenen Konversationen");
  }

  async getQuery(): Promise<Query> {
    return query(
      this.defaultQuery,
      where("unread", "==", false),
      where("snoozed", "<=", new Date()),
      where("operator", "==", store.getters[UserStore.Getters.UID]),
      orderBy("snoozed", "desc")
    );
  }
}
